import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Separator } from '../ui/separator';
import { Edit2, Euro } from 'lucide-react';
import { getTypeIcon } from './catalogShared';

export function CatalogItemDetailDialog({ open, onOpenChange, detailItem, onEdit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Scheda Articolo</DialogTitle>
        </DialogHeader>

        {detailItem && (
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <Badge variant="outline" className="flex items-center gap-1">
                {getTypeIcon(detailItem.type_code)}
                {detailItem.type_name || detailItem.type_code}
              </Badge>
              {detailItem.is_active ? (
                <Badge className="bg-green-100 text-green-800">Attivo</Badge>
              ) : (
                <Badge variant="outline">Inattivo</Badge>
              )}
            </div>

            <div>
              <p className="text-sm text-muted-foreground">Codice</p>
              <p className="font-mono">{detailItem.item_code}</p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-muted-foreground">Marca</p>
                <p className="font-medium">{detailItem.brand}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Modello</p>
                <p className="font-medium">{detailItem.model}</p>
              </div>
            </div>

            {detailItem.description && (
              <div>
                <p className="text-sm text-muted-foreground">Descrizione</p>
                <p>{detailItem.description}</p>
              </div>
            )}

            {detailItem.prezzo_listino && (
              <div>
                <p className="text-sm text-muted-foreground">Prezzo Listino</p>
                <p className="text-lg font-semibold flex items-center gap-1">
                  <Euro className="h-4 w-4" />
                  {detailItem.prezzo_listino.toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                </p>
              </div>
            )}

            {Object.keys(detailItem.technical_specs || {}).length > 0 && (
              <>
                <Separator />
                <div>
                  <p className="text-sm text-muted-foreground mb-2">Specifiche Tecniche</p>
                  <div className="grid grid-cols-2 gap-2">
                    {detailItem.type_field_schema?.map(field => {
                      const value = detailItem.technical_specs[field.name];
                      if (value === undefined || value === null || value === '') return null;
                      return (
                        <div key={field.name} className="text-sm">
                          <span className="text-muted-foreground">{field.label}:</span>{' '}
                          <span className="font-medium">
                            {typeof value === 'boolean' ? (value ? 'Sì' : 'No') : value}
                            {field.unit && ` ${field.unit}`}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            )}

            {detailItem.notes && (
              <div>
                <p className="text-sm text-muted-foreground">Note</p>
                <p className="text-sm">{detailItem.notes}</p>
              </div>
            )}
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Chiudi
          </Button>
          <Button onClick={() => onEdit(detailItem)}>
            <Edit2 className="h-4 w-4 mr-2" />
            Modifica
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
